import React, { Component } from 'react'
// import { NavLink } from 'react-router-dom'
import NavLink from '../components/LinkHack'
import data from '../data/footer_links' // TODO: use this.props.data
import shortid from 'shortid'
import PropTypes from 'prop-types'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react/index'

@inject('user')
@observer
class FooterColumns extends Component {
  render () {
    console.log('FooterColumns - data:', data)

    const {user} = this.props
    let {categories} = this.props

    console.log('FooterColumns - categories:', categories)

    let categories_links = {}

    // Sort
    if (Array.isArray(categories) && categories.length > 1) {
      let sort_by_description = (a, b) => a.description.localeCompare(b.description)
      categories = [...categories]
      categories.sort(sort_by_description)
    }

    for (let category of categories) {
      categories_links[category.description] = '/category/' + category.id
    }

    let categories_column = {
      title: 'Erlebnisse',
      links: categories_links
    }

    console.log('FooterColumns - categories_column:', categories_column)

    let columns = [
      categories_column,
      ...data
    ]

    if (user.login) {
      columns = [
        ...columns,
        {
          'title': 'Mein FUNORO',
          'links': {
            'Dashboard': '/profile',
            'Benachrichtigungen': '/notifications',
            'Meine Erlebnisse': '/my-experiences',
            'Meine Buchungen': '/my-bookings',
            'Wunschliste': '/my-wishlist',
            'Einstellungen': '/settings'
          }
        }
      ]
    }

    console.log('FooterColumns - columns:', columns)

    return columns.map((column, columnIndex) =>
      <div className='b-footer-column' key={shortid.generate()}>
        <div className='b-footer-column-title'>
          {column.title}
        </div>
        {Object.keys(column.links).map((key, linkIndex) =>
          // key is string concatenation of column and link indexes
          <NavLink to={column.links[key]} className='b-footer-column-link' key={shortid.generate()}>
            {key}
          </NavLink>)
        }
      </div>
    )
  }
}

FooterColumns.defaultProps = {
  categories: []
}

FooterColumns.propTypes = {
  categories: PropTypes.any,
  user: MobxPropTypes.observableObject
}

export default FooterColumns



// WEBPACK FOOTER //
// ./src/components/FooterColumns.js